import { render, staticRenderFns } from "./Support2.vue?vue&type=template&id=6f5f5bba&scoped=true"
import script from "./Support2.vue?vue&type=script&lang=js"
export * from "./Support2.vue?vue&type=script&lang=js"
import style0 from "./Support2.vue?vue&type=style&index=0&id=6f5f5bba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5f5bba",
  null
  
)

export default component.exports